import { render, staticRenderFns } from "./TokenDialog.vue?vue&type=template&id=d04bdcb6&scoped=true"
import script from "./TokenDialog.vue?vue&type=script&lang=js"
export * from "./TokenDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=d04bdcb6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04bdcb6",
  null
  
)

export default component.exports